export default "__VITE_ASSET__DGWz8IXm__"